(function moreInfoPanel(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewer.CopyLink ||
    !global.NewHomeSource.FullImageViewer.UrlHandler ||
    !global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const previousMoreInfoPanel = global.NewHomeSource.FullImageViewer.MoreInfoPanel;
  const queryPanelForm = '[data-panel-form]';
  const queryCancelButton = '[data-close-panel-action]';
  const queryMoreInfoButton = '[data-more-information-btn]';
  const queryScheduleTour = '[data-schedule-panel-actions]';
  const queryContactBuilder = '[data-contact-builder-panel-actions]';
  const queryAskQuestion = '[data-ask-question-panel-actions]';
  const queryContactAgent = '[data-contact-agent-panel-actions]';
  const queryEmail = '[data-email]';
  const queryRevealPhoneText = '[data-phone-reveal-text]';
  const queryMoreInfo = '[data-more-info]';
  const queryScheduleTourCallToAction = '[data-component="full-image-viewer-schedule-tour-cta"]';
  const queryFreeBrochureCallToAction = '[data-component="full-image-viewer-free-brochure-cta"]';
  const panelForm = global.document.querySelector(queryPanelForm);
  const moreInfoButton = global.document.querySelector(queryMoreInfoButton);
  const elementsActions = global.document.querySelectorAll(queryMoreInfo);
  const panelActionContainer = global.document.querySelector('[data-panel-actions]');
  const revealPhoneTextOnPage = global.document.querySelector('p' + queryRevealPhoneText);
  const hiddePhoneText = revealPhoneTextOnPage && revealPhoneTextOnPage.hidden;
  const revealPhoneTextFullImageViewer = global.document.querySelector(queryMoreInfo + queryRevealPhoneText);
  const revealPhoneNumberFullImageViewer = global.document.querySelector(queryMoreInfo + '[data-phone-reveal-number]');
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();
  const backButton = document.querySelector('[data-component="close-form"]');
  const hidden = 'hidden';
  const trackingQueryString = encodeURIComponent('utm_source=Social&medium=Email&utm_campaign=EmailFromFWIV');

  /**
   * @constructs NewHomeSource.FullImageViewer.MoreInfoPanel
   */
  function MoreInfoPanel() {
  }

  /**
 * @private
 * openPanelActions: open panel actions when user click more information button or close button.
 *
 */
  function openPanelActions() {
    backButton.dataset.ga4EventClick_target = 'CTA back clicked';
    global.NewHomeSource.FullImageViewer.CopyLink.toggleCopyAlert();
    if (moreInfoButton) {
      moreInfoButton.setAttribute(hidden, '');
    }

    const isPhoneNumberVisible = revealPhoneNumberFullImageViewer &&
      revealPhoneNumberFullImageViewer.style.display === 'block';

    for (let index = 0; index < elementsActions.length; index += 1) {
      elementsActions[index].removeAttribute(hidden);
    }

    if (hiddePhoneText || isPhoneNumberVisible) {
      revealPhoneTextFullImageViewer.setAttribute(hidden, '');
      revealPhoneNumberFullImageViewer.classList.remove('form__number');
    }
    requestAnimationFrame(global.NewHomeSource.GalleryTab.showArrows);
  }

  /**
 * @private
 * closePanelActions: close panel actions when user click more information button or close button.
 *
 */
  function closePanelActions() {
    if (moreInfoButton) {
      moreInfoButton.removeAttribute(hidden);
    }

    for (let index = 0; index < elementsActions.length; index += 1) {
      elementsActions[index].setAttribute(hidden, '');
    }
    requestAnimationFrame(global.NewHomeSource.GalleryTab.showArrows);
  }

  MoreInfoPanel.closePanelActions = closePanelActions;

  /**
 * @private
 * openScheduleForm: open schedule form on panel actions.
 *
 */
  function openScheduleForm() {
    panelActionContainer.setAttribute(hidden, '');
    global.NewHomeSource.FullImageViewer.ScheduleTour.setUpScheduleTour();
  }

  /**
 * @private
 * openFreeBrochureForm: open freeBrochure form on panel actions.
 *
 */
  function openFreeBrochureForm(event) {
    const modalUrl = event && event.target
      ? event.target.dataset.modalUrl
      : '';
    const doesFreeBrochureAlreadyLoaded = !!panelForm.querySelector('[data-form-container]');

    if (doesFreeBrochureAlreadyLoaded || !modalUrl) {
      return;
    }

    panelActionContainer.setAttribute(hidden, '');
    global.NewHomeSource.FullImageViewer.FreeBrochureHandler.Init(panelForm, modalUrl);

    openPanelActions();
    panelForm.removeAttribute('hidden');
  }

  /**
 * @private
 * openContactBuilderForm: open contact builder form on panel actions.
 *
 */
  function openContactBuilderForm(event) {
    panelActionContainer.setAttribute(hidden, '');
    global.NewHomeSource.FullImageViewer.ScheduleTour.setUpContactBuilder(event);
  }

  /**
* @private
* onClickEmail: open malito.
*
*/
  function onClickEmail() {
    document.location.href = 'mailto:?body=' + global.NewHomeSource
      .FullImageViewer.UrlHandler.insertQueryString(window.location.href, trackingQueryString);
  }

  /**
* @private
* openAskQuestionForm: open ask question form on panel actions.
*
*/
  function openAskQuestionForm(event) {
    openContactBuilderForm(event);
  }

  /**
* @private
* openBasicForm: open any basic form on panel actions, the form type
* is added on the current event element like a data parameter.
*/
  function openBasicForm(event) {
    const querySelectorTeplate = event.currentTarget ? event.currentTarget.getAttribute('data-query-template') : '';

    if (querySelectorTeplate) {
      panelActionContainer.setAttribute(hidden, '');
      global.NewHomeSource.FullImageViewer.FullImageViewerBasicFormsHandlerLoader
        .loadBasicForm(panelForm, querySelectorTeplate);
    }

    if (!window.Mailcheck && typeof global.NHS.loadJs === 'function') {
      global.NHS.loadJs(document.getElementById('CtaDependencies').value);
    } else if (window.NewHomeSource && window.NewHomeSource.EmailDomainValidator) {
      window.NewHomeSource.EmailDomainValidator();
    }
  }

  function logViewPhoneNumber() {
    const leadEvents = global.NewHomeSource.Modules.tagManager.getFromDataLayer('leadEvents') || {};
    this.dataset.ga4EventPosition = leadEvents.Position || this.dataset.ga4EventPosition;
  }

  /**
  * @public
  *
  * openContactBuilderFromCallToAction: Exposes the open the schedule tour panel.
  */
  MoreInfoPanel.openScheduleTourFromCallToAction = function openScheduleTourFromCallToAction() {
    openPanelActions();
    openScheduleForm();
  };

  /**
  * @public
  *
  * openContactBuilderFromCallToAction: Exposes the open the contact builder panel.
  */
  MoreInfoPanel.openContactBuilderFromCallToAction = function openContactBuilderFromCallToAction() {
    openPanelActions();
    openContactBuilderForm();
    backButton.dataset.ga4EventClick_target = 'Banner CTA back clicked';
  };

  const eventsConfiguration = {
    moreInfoButton: {
      callbacks: [openPanelActions],
      events: [eventToAttach],
      elements: queryMoreInfoButton,
    },
    closePanelAction: {
      callbacks: [closePanelActions],
      events: [eventToAttach],
      elements: queryCancelButton,
    },
    scheduleTourButton: {
      callbacks: [openScheduleForm],
      events: [eventToAttach],
      elements: queryScheduleTour,
    },
    contactBuilderButton: {
      callbacks: [openContactBuilderForm],
      events: [eventToAttach],
      elements: queryContactBuilder,
    },
    askQuestionButton: {
      callbacks: [openAskQuestionForm],
      events: [eventToAttach],
      elements: queryAskQuestion,
    },
    contactAgentButton: {
      callbacks: [openBasicForm],
      events: [eventToAttach],
      elements: queryContactAgent,
    },
    emailButton: {
      callbacks: [onClickEmail],
      events: [eventToAttach],
      elements: queryEmail,
    },
    openScheduleTourFromCta: {
      callbacks: [MoreInfoPanel.openScheduleTourFromCallToAction],
      events: [eventToAttach],
      elements: queryScheduleTourCallToAction,
    },
    openFreeBrochureFromCta: {
      callbacks: [openFreeBrochureForm],
      events: [eventToAttach],
      elements: queryFreeBrochureCallToAction,
    },
    revealPhoneEvent: {
      callbacks: [logViewPhoneNumber],
      events: [eventToAttach],
      elements: queryMoreInfo + queryRevealPhoneText
    }
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer.MoreInfoPanel to the previous script.
   */
  MoreInfoPanel.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.MoreInfoPanel = previousMoreInfoPanel;
    return MoreInfoPanel;
  };

  global.NewHomeSource.Event(eventsConfiguration);
  global.NewHomeSource.FullImageViewer.MoreInfoPanel = MoreInfoPanel;
}(window));
